require('./video_items_manager')

SharedPlayer = LP.module('SharedPlayer')

class AudioItemsManager
  @stopAudioIfPlaying: ($slide) ->
    slideData = $slide.data()
    return unless slideData && slideData['type'] == 'audio'
    Mp3AudioFile.stopAudioIfPlaying($slide)

  @showAudio: ($slideElement, data) =>
    Mp3AudioFile.showMp3Audio($slideElement, data)

class Mp3AudioFile

  @stopAudioIfPlaying: ($slideElement) ->
    data = $slideElement.data()
    return unless data?
    $audioContainer = $slideElement.find("#audio-item-#{data.id}")
    if $audioContainer.length > 0
      $audioContainer[0].pause()

  @bindOnError: ($slideElement, data) ->
    $videoContainer = $slideElement.find("#audio-item-#{data.id}")
    $($videoContainer).on 'error', ->
      SharedPlayer.PlayerItemRenderer._showNonInteractive($slideElement, data)

  @showMp3Audio: ($slideElement, data) ->
    $slideElement.html("
      <div class='file-audio-container'>
        <div id='file-audio-wrapper'>
          <div class='audio-item-title'> #{data.title} </div>
          <audio id='audio-item-#{data.id}' class='audio-player' controls>
            <source src='#{data.url}' type='audio/mpeg'>
            Your browser does not support the audio element.
          </audio>
        </div>
      </div>
    ")
    Mp3AudioFile.bindOnError($slideElement, data)
    $slideElement.fitVids({ customSelector: ".file-audio-container" })
    SharedPlayer.VideoItemsManager.resizeSlide($slideElement)

SharedPlayer.AudioItemsManager = AudioItemsManager
LP.module('SharedCollections').AudioItemsManager = AudioItemsManager
